import gql from 'graphql-tag';

const mutation = gql`
  mutation UpdateUserPhoneNumber($params: UpdateUserPhoneNumberParams!) {
    updateUserPhoneNumber(params: $params)
  }
`;

export default mutation;
